import {injectReducer} from '@/redux/store';
import {startAppListening} from '@/redux/store/listenerMiddleware';

import {addFeatureListeners} from './featureListeners';
import {reducer, SLICE_NAME} from './slice';

addFeatureListeners(startAppListening);
injectReducer(SLICE_NAME, reducer);
